"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  ${dir("rtl")`
    transform: scaleX(-1);
  `}
`;
const Image = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M20 4.75L19.25 4v16l.75-.75H4l.75.75V4L4 4.75h16zM3.25 4v16c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0-.75.75zm11.07 8.888c.23-.357.606-.353.828-.008l2.887 4.482c.227.352.06.638-.357.638H6.326c-.421 0-.581-.3-.37-.648l4.006-6.622c.217-.358.567-.359.793.014l2.396 3.96 1.17-1.816zm1.59-2.735c1.14 0 2.066-.907 2.066-2.026 0-1.12-.926-2.027-2.067-2.027s-2.066.907-2.066 2.027c0 1.119.925 2.026 2.066 2.026z", children: " " })
] });
var Image_default = Image;
export {
  Image_default as default
};
